(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_head"] && !Shopify.designMode) return;
  try {
    
    function animateBlocks() {
      getBlock().forEach((item) => {
        item.classList.add('loaded');
      });
    }
    const swiper = new Swiper('.swiper', {
      effect: 'fade',
      speed: 400,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 7000,
      },
      on: {
        init: function () {
          // 初始化时立即执行动画
          animateBlocks();
        },
        slideChangeTransitionStart: function () {
          // 移除所有元素的 loaded 类（重置动画）
          getBlock().forEach((item) => {
            item.classList.remove('loaded');
          });
        },
        slideChangeTransitionEnd: function () {
          // 切换结束后添加 loaded 类（触发动画）
          animateBlocks();
        },
      },
    });
  
  } catch(e) { console.error(e); }
})();
})();
